export default "__VITE_ASSET__BNfBv5pZ__"